import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ScheduleService } from '../services/schedule.service';
import { SchedulePostDTO } from './schedulepostdto';

import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';

@Component({
    selector: 'app-addschedule',
    templateUrl: './addschedule.component.html',
    styleUrls: ['./addschedule.component.css'],
    providers: [ScheduleService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AddscheduleComponent implements OnInit {
  constructor(private scheduleService: ScheduleService, private router: Router, private formBuilder: UntypedFormBuilder) { }
  addScheduleForm: UntypedFormGroup;

  minDate: string;

  onSubmit() {
    // Keep the date in yyyy-mm-dd format and construct it in local time.
    const dateValue = (this.addScheduleForm.get('myDate')?.value as string) ?? '';
    const [year, month, day] = dateValue.split('-').map(Number);
    const localDate = new Date(year, month - 1, day);
    const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(dateValue) &&
      localDate.getFullYear() === year &&
      localDate.getMonth() === month - 1 &&
      localDate.getDate() === day;

    if (!isValidDate || dateValue < this.minDate) {
      this.addScheduleForm.get('myDate')?.setErrors({ invalidDate: true });
      return;
    }
    const myStartTime = this.addScheduleForm.get('starttime')?.value as string;
    const myEndTime = this.addScheduleForm.get('endtime')?.value as string;

    let myStartDate: Date | null = null;
    let myEndDate: Date | null = null;

    // Create start date in local timezone and convert to UTC
    if (myStartTime != null && myStartTime !== '') {
      const startDate = new Date(localDate);
      startDate.setHours(parseInt(myStartTime.split(':')[0]), parseInt(myStartTime.split(':')[1]), 0, 0);
      // Convert local time to UTC by using the timestamp
      myStartDate = new Date(startDate.toISOString());
    }

    // Create end date in local timezone and convert to UTC
    const endDate = new Date(localDate);
    endDate.setHours(parseInt(myEndTime.split(':')[0]), parseInt(myEndTime.split(':')[1]), 0, 0);
    // Convert local time to UTC by using the timestamp
    myEndDate = new Date(endDate.toISOString());

    const postObject = new SchedulePostDTO(this.addScheduleForm.get('switch')?.value, myStartDate, myEndDate);
    this.scheduleService.postSchedule(JSON.stringify(postObject))
    .subscribe(result => {
      this.router.navigate(['/schedule/']);
    });
  }

  ngOnInit() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    this.minDate = this.toDateInputValue(d);

    this.addScheduleForm = this.formBuilder.group({
      switch: ['51', Validators.required],
      myDate: [this.toDateInputValue(new Date()), [Validators.required, Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      endtime: ['06:30', Validators.required],
      starttime: [''],
    });
  }

  private toDateInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
